module.exports = __WEBPACK_EXTERNAL_MODULE__8670__;